module.exports = __webpack_public_path__ + "static/img/3.1.75091bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/3.1.png
// module id = 6UvU
// module chunks = 0